export default "__VITE_ASSET__C26u6Qp6__"